export default "__VITE_ASSET__cLZLOsSELI_GmwKcVOKKRw__";